import LazyImage from "@eisinc/MobiusOverrides/LazyImage";

export default LazyImage;

export * from "@eisinc/MobiusOverrides/LazyImage";
